import * as React from 'react';

import { useDegreeContext } from 'bundles/degree-home/components/v2/DegreeHomeContext';

const DEGREES = {
  BOULDER_MSCI_DATASCI: 'base~gm86sK3SS2uI9JpLe8i1Fg',
  BOULDER_MSCI_COMPSCI: 'base~eB1--NcpSZ2Z7sm2xYFYAQ',
  BALL_STATE_MS_IN_DS: 'base~Zy6INhd1SlmzEVkPddNDAA',
  BALL_STATE_MS_IN_CS: 'base~JmDnsiyWQdGU1VWg2Wrecw',
  ILLINOIS_TECH_MAS_DS: 'base~9UdXnRZVQ_WE49Rnetjdyw',
  ILLINOIS_TECH_MBA: 'base~Yef4yWPzQfCerYGpAQ_lng',
  ILLINOIS_TECH_MAS_IT: 'base~Qn0xe36HTd-1-ZOwNwbBmQ',
  ILLINOIS_TECH_BACH_IT: 'base~zWOAa7coQWeqlKDwC6l9IA',
  UNIANDES_MISO: 'base~QoIB-um0Q8a553qvfrj0VQ',
  UOL_BSC_CS: 'base~O30WHIkRQJ-vtPeTt_a7xw',
  NORTH_EASTERN_MS_IS: 'base~in5Wmft6RbKp0-Otuku1Bg',
  PITT_MS_DS: 'base~AOzsuBoSRgea2iA8IFvtYA',
};

const DEGREES_THAT_SUPPORT_STACKABILITY = [
  DEGREES.BALL_STATE_MS_IN_DS,
  DEGREES.BALL_STATE_MS_IN_CS,
  DEGREES.ILLINOIS_TECH_MAS_DS,
  DEGREES.ILLINOIS_TECH_MBA,
  DEGREES.ILLINOIS_TECH_MAS_IT,
  DEGREES.ILLINOIS_TECH_BACH_IT,
  DEGREES.UNIANDES_MISO,
  DEGREES.UOL_BSC_CS,
  DEGREES.PITT_MS_DS,
];

const DEGREES_THAT_SUPPORT_PBA_ONLY = [
  DEGREES.BOULDER_MSCI_DATASCI,
  DEGREES.BOULDER_MSCI_COMPSCI,
  DEGREES.BALL_STATE_MS_IN_CS,
  DEGREES.BALL_STATE_MS_IN_DS,
  DEGREES.ILLINOIS_TECH_MBA,
  DEGREES.ILLINOIS_TECH_MAS_DS,
  DEGREES.ILLINOIS_TECH_BACH_IT,
  DEGREES.NORTH_EASTERN_MS_IS,
  DEGREES.PITT_MS_DS,
];

interface ProgramVariationContext {
  /** Whether this program supports open stackable content */
  supportsStackability: boolean;
  /**  Whether the performance-based admissions process is the only way to get admitted into this program */
  supportsPBAOnly: boolean;
}
const programVariationContext = React.createContext<ProgramVariationContext>({
  supportsStackability: false,
  supportsPBAOnly: false,
});

export const useProgramVariation = () => React.useContext(programVariationContext);

/** A temporary implementation of program-level variations before we can commit it to the BE */
export const ProgramVariationProvider: React.FC<{ __overrideForStorybook?: ProgramVariationContext }> = ({
  children,
  __overrideForStorybook,
}) => {
  const { Provider } = programVariationContext;

  const { degreeId } = useDegreeContext();

  if (__overrideForStorybook) {
    return <Provider value={__overrideForStorybook}>{children}</Provider>;
  }

  const supportsStackability = DEGREES_THAT_SUPPORT_STACKABILITY.includes(degreeId);
  const supportsPBAOnly = DEGREES_THAT_SUPPORT_PBA_ONLY.includes(degreeId);
  return <Provider value={{ supportsStackability, supportsPBAOnly }}>{children}</Provider>;
};
